import axios from 'axios';
import { opportunityMobilizationsService } from '@/services/opportunity-mobilizations.service';

const initialState = () => ({
  directions: null,
  status: {
    error: null,
    pending: false,
    pendingEdit: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getOpportunityMobilizationDirections({ commit }, { opportunityId, mobilizationId }) {
    commit('GET_OPPORTUNITY_MOBILIZATION_DIRECTIONS');

    return opportunityMobilizationsService.getOpportunityMobilizationDirections({ opportunityId, mobilizationId }).then(
      (directions) => {
        commit('GET_OPPORTUNITY_MOBILIZATION_DIRECTIONS_SUCCESS', directions);
        return directions;
      },
      (error) => {
        if (!axios.isCancel(error)) {
          commit('ERROR', error);
        }
      },
    );
  },
  recomputeOpportunityMobilizations({ commit }, { opportunityId }) {
    commit('RECOMPUTE_OPPORTUNITY_MOBILIZATIONS');

    return opportunityMobilizationsService.recomputeOpportunityMobilizations({ opportunityId }).then(
      () => {
        commit('RECOMPUTE_OPPORTUNITY_MOBILIZATIONS_SUCCESS');
      },
      (error) => {
        if (!axios.isCancel(error)) {
          commit('ERROR', error);
        }
      },
    );
  },
};

const mutations = {
  GET_OPPORTUNITY_MOBILIZATION_DIRECTIONS(state) {
    state.directions = null;
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  GET_OPPORTUNITY_MOBILIZATION_DIRECTIONS_SUCCESS(state, directions) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.directions = directions;
  },
  RECOMPUTE_OPPORTUNITY_MOBILIZATIONS(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  RECOMPUTE_OPPORTUNITY_MOBILIZATIONS_SUCCESS(state) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
  },
  ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
    state.directions = null;
  },
};

const getters = {
  directions: (state) => state.directions,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const opportunityMobilizations = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
